export default "__VITE_ASSET__fgzwQIqh__"